<template>
<div style="text-align:center" class="cursor-pointer "  @click="moveTo()" v-if="activeQuestion">
  <div class="mt-4">
    <h5 class="mb-2" v-if="activeQuestion.id != data.id">문제 {{getIndex()}}</h5>
    <h5 class="mb-2" v-if="activeQuestion.id == data.id" style="color:red">문제 {{getIndex()}}</h5>
  </div>
  <vs-divider />
</div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      active: false,
    }
  },
  methods: {
    getIndex() {
      return this.questionList.findIndex((item) => item.id == this.data.id) + 1
    },
    moveTo() {
      this.$store.commit('etest/ACTIVE_QUESTION', this.data)
      this.$emit('close')
    }
  },
  computed: {
    questionList() {
      return this.$store.state.etest.questionList
    },
    activeQuestion() {
      return this.$store.state.etest.activeQuestion
    },
  }
}
</script>

<style lang="scss">
// ///////////////////////////////////////////////
// Page Slide
// ///////////////////////////////////////////////
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity .35s, transform .4s;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateX(-30%);
}

.slide-fade-leave-to{
    opacity: 0;
    transform: translateX(30%);
}

</style>
